//onUpdate - triggers each time the world updates (essentially continuous)
export default function onUpdate(callback) {
  this.continuous.push(() => callback());
}
